export const EVENT_PHASER_OPENER = 'openPhaser';
